<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<template>
  <b-table
    responsive
    stacked="sm"
    no-border-collapse
    small
    :busy="processing"
    :items="items"
    :fields="fields"
    show-empty
  >
    <template
      #cell(destination)="{
        item: {
          destination: { type, city_name },
        },
      }"
    >
      <p>{{ type }}</p>
      <p>{{ city_name }}</p>
    </template>
    <template #cell(state_ticket)="{ item: { state_ticket } }">
      <span v-if="state_ticket" class="column-state" :class="state_ticket">
        <img
          alt="state"
          v-if="state_ticket !== 'not_available'"
          :src="
            require(`@/assets/modules/permisos-sindicales/icons/${state_ticket}.svg`)
          "
        />
        {{ translateState(state_ticket) }}
      </span>
    </template>
    <template #cell(options)="{ item }">
      <span class="p-1 pointer" @click.prevent="show(item)">
        <img
          alt="show"
          :src="
            require('@/assets/modules/permisos-sindicales/icons/tables/eye-line.svg')
          "
        />
      </span>
    </template>
    <template #table-busy>
      <p class="center">Cargando ...</p>
    </template>
    <template #empty>
      <p class="center">Sin registros para mostrar.</p>
    </template>
  </b-table>
</template>

<style lang="scss" src="./styles.scss" />
